
// 路由按需加载
export const routes = [
  {
    path: '/vipWechatPay',
    name: '魔音工坊',
    component: () => import(/* webpackChunkName: "channel" */ '@/views/VipWechatPay/index.vue'),
    meta: {}
  }
]
